import { compareMatchWithCollection } from '@bimser/core';
import get from 'lodash/get';
import { IControlProperties } from '../../../../entities/IControlProperties';
import { IDataGridColumn } from '../../entities';
import { CustomizedDxColumn } from './generateColumns';
import { iconTextRenderer } from './iconTextRenderer';

export const IconMatcherCellComponent = props => {
	const bcColumn: IDataGridColumn<IControlProperties> = (props.data.column as CustomizedDxColumn)
		.retrieveDataGridInstance()
		.__getBCColumn(props.data.column.name);

	const iconSourceFieldsValue = get(props.data.row.data, bcColumn.iconSourceField);

	const match = bcColumn.iconMatchers.find(matcher =>
		compareMatchWithCollection({
			value: iconSourceFieldsValue,
			compareValue: matcher.value,
			dataType: bcColumn.dbType.type,
			editType: bcColumn.editType,
			format: bcColumn.format
		})
	);

	if (match) {
		return iconTextRenderer(props.data.text, match.icon);
	}

	return props.data.text;
};
